<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        color="primary"
        v-on="on"
      >
        <v-icon>
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Job Group"
      text="Edit Job Group"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="localJobGroup.name"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
                outlined
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete 
                v-model="localJobGroup.job_group_policy_id"
                :error-messages="errors.collect('jobGroupPolicy')"
                :items="jobGroupPolicies"
                data-vv-name="jobGroupPolicy"
                data-vv-as="job group policy"
                item-text="name"
                item-value="id"
                hide-selected
                outlined
                clearable
                label="Job Group Policy"
              />
            </v-col>
            
            <v-col cols="12">
              <v-autocomplete
                v-model="leaveEntitlementSetting"
                :error-messages="errors.collect('leaveEntitlementSetting')"
                data-vv-name="leaveEntitlementSetting"
                data-vv-as="leave entitlement"
                :items="leaveEntitlementSettings"
                multiple
                chips
                hide-no-data
                outlined
                hide-selected
                item-text="name"
                item-value="id"
                deletable-chips
                label="Leave Entitlement"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"  
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"          
          class="white--text px-10"
          @click="submitForm"  
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      jobGroup: {
        type: Object,
        default: null,
      },  
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        leaveEntitlementSettings: [],
        leaveEntitlementSetting: [],
        jobGroupPolicies: [],
        localJobGroup: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.localJobGroup = { ...this.jobGroup }

          this.loadJobGroupPolicies()
          this.loadLeaveEntitlementSettings()

          this.jobGroup.job_group_leave_entitlement_settings.map(item => {
            this.leaveEntitlementSetting.push(item.leave_entitlement_setting_id)
          })
        } else {
          this.leaveEntitlementSetting = []
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.jobGroups().update(this.jobGroup.id, this.prepareFormData())
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          name: this.localJobGroup.name,
          job_group_policy_id: this.localJobGroup.job_group_policy_id,
          leaveEntitlementSettings: this.leaveEntitlementSetting,
        }
      },
      loadJobGroupPolicies () {
        this.$api.jobGroupPolicies().list()
          .then(response => {
            this.jobGroupPolicies = _.orderBy(response.data, ['code'], ['asc'])
          })
      },
      loadLeaveEntitlementSettings () {
        this.$api.leaveEntitlementSettings().list()
          .then(res => {
            this.leaveEntitlementSettings = res.data
          })
      },
    },
  }
</script>
